import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import apiInstance from "../../config/api"; 

// Report a user
export const reportUser = createAsyncThunk(
  "report/create",
  async ({ reportedId, reason }, { rejectWithValue }) => {
    try {
      const request = await apiInstance.post("/api/admin/temp/report/user", {
        reportedId,
        reason,
      });

      const response = request.data;

      if (response.status === "success") {
        toast.success("User reported successfully ✅");
        return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// (optional, for later) Fetch all reports (Admin use)
export const getReports = createAsyncThunk(
  "report/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const request = await apiInstance.get("/api/admin/temp/report");
      return request.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
